






































































































import { Vue, Component, Watch } from "vue-property-decorator";
import { auth, busy, vip, settings, toaster } from '@/loader/public';
import SidebarMenu from "./component/SidebarMenu.vue";
import SidebarHelp from "./component/SidebarHelp.vue";
import CompanyModal from "./component/company/CompanyModal.vue";
import CapabilityModal from "./component/capability/CapabilityModal.vue";

@Component({
	components: {
		SidebarMenu,
		SidebarHelp,
		CompanyModal,
		CapabilityModal,
	}
})
export default class App extends Vue {
	public search: string = "";

	public chars = [
		["Ø", "±", "≤", "≥", "‰"],
		["À", "Ç", "É", "È", "œ", "Œ"],
	];

	public get canCopyToClipboard(): boolean {
		return Boolean(navigator.clipboard?.writeText);
	}

	public get isLoggedIn(): boolean {
		return auth.isLoggedIn;
	}

	public get isBusy(): boolean {
		return busy.status;
	}

	public get overlayText(): string {
		return busy.text;
	}

	public get overlayOptions(): BusyOverlayOptions {
		return busy.overlayOptions;
	}

	public get overlayIcon() {
		return busy.icon;
	}

	public get logo() {
		return settings.logo_url;
	}

	public get company_name() {
		return settings.company_name;
	}

	public get animations() {
		let prefix = "animate__animated animate__faster animate__";
		return {
			appear: true,
			enterActiveClass: vip.animationEnterActive ? prefix + vip.animationEnterActive : "",
			leaveActiveClass: vip.animationLeaveActive ? prefix + vip.animationLeaveActive : "",
			appearActiveClass: vip.animationAppearActive ? prefix + vip.animationAppearActive : "",
		};
	}

	public doSearch() {

	}

	public companySaved() {
		if (vip.company && (this.$route.name !== "Company" || Number(this.$route.params.id) !== vip.company.id)) {
			this.$router.push({ name: "Company", params: { id: vip.company.id } });
		}
		vip.hideCompany();
	}

	public companyCancelled() {
		vip.hideCompany();
	}

	public companyRemoved() {
		vip.hideCompany();
		if (this.$route.name === "Company") {
			this.$router.push({ name: "Companies" });
		}
	}

	public capabilitySaved() {
		if (vip.capability && (this.$route.name !== "Capability" || Number(this.$route.params.id) !== vip.capability.id) && this.$route.name !== "CapabilityRequest") {
			this.$router.push({ name: "Capability", params: { id: vip.capability.id } });
		}
		vip.hideCapability();
	}

	public capabilityCancelled() {
		vip.hideCapability();
	}

	public capabilityRemoved() {
		vip.hideCapability();
		if (this.$route.name === "Capability") {
			this.$router.push({ name: "Capabilities" });
		}
	}

	public copy(text: string) {
		navigator.clipboard.writeText(text).then(() => {
			toaster.toast({ message: `Texte "${text}" copié`, variant: "info" });
		}).catch(() => {
			toaster.toast({ message: `Le texte "${text}" n'a pas pu être copié. Attention, la fonction de copie n'est pas prise en charge sur les anciens navigateurs. Vous devez utiliser au minimum Edge 79, Firefox 63, Chrome 66 ou Safari 13.1 pour pouvoir bénéficier de cette fonctionnalité.`, variant: "warning", noAutoHide: false, autoHideDelay: 2000 });
		});
	}

	@Watch("isLoggedIn", { immediate: true })
	public loginChanged(newValue: boolean, oldValue?: boolean) {
		if (!newValue && newValue !== oldValue && auth.initialized) {
			if (this.$router.currentRoute.name !== "Login") {
				this.$router.push({ name: "Login" });
			}
		} else if (newValue && oldValue === false && auth.initialized) {
			if (this.$router.currentRoute.name !== "Home") {
				this.$router.push({ name: "Home" });
			}
		}
	}
}
